<template>
  <div class="flex-display mg-t-3 pd-b-3 border-b" :class="{ 'opacity-05':disabled}">
    <div @click="disabled?null:$router.push(`/course/detail?courseId=${id}`)" :class="disabled?'cursor-not-allowed':'cursor-pointer'">
      <div
        class="query-course-image"
        :style="`background-image:url(` + urlImage + `);`"
      ></div>
    </div>
    <div class="text-left mg-l-2 width-100">
      <div class="flex-display js-between ">
        <div @click="disabled?null:$router.push(`/course/detail?courseId=${id}`)" class="name-course" :class="disabled?'cursor-not-allowed':'cursor-pointer'">
          <p class="text-font-16 mg-t-less text-weight-600 text-break-word">หลักสูตร {{ name }}</p>
        </div>

          <p v-if="totaltimeCourse" class="color-gray mg-t-less text-font-14">
            เวลาเรียน {{totaltimeCourse}} ชั่วโมง
          </p>
      
      </div>

      <p class="text-font-14 text-weight-normal">คำอธิบายหลักสูตร</p>
      <viewer v-if="description" :initialValue="description" />
    </div>
  </div>
</template>

<script>
import { Viewer } from "@toast-ui/vue-editor";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    viewer: Viewer,
  },
  props: {
    id: {
      type: String,
      default() {
        return "";
      },
    },
    image: {
      type: String,
      default() {
        return "";
      },
    },
    name: {
      type: String,
      default() {
        return "";
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    urlImage() {
      if (this.image != "") {
        return `${this.urlCouse}/${this.id}/${this.image}`;
      } else {
        return "https://1080motion.com/wp-content/uploads/2018/06/NoImageFound.jpg.png";
      }
    },
    totaltimeCourse() {
      let time = 0
      this.courseSubjects.map((item) => {
        
        let hours =
          item.totalStudyTime && item.totalStudyTime.hours
            ? item.totalStudyTime.hours
            : 0;
        let minute =
          item.totalStudyTime && item.totalStudyTime.minute
            ? item.totalStudyTime.minute
            : 0;

        time = time + (hours*60) + minute
      });

      return `${parseInt(time/60)}.${time - (parseInt(time/60) * 60) }`;
    },
  },
  data() {
    return {
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
      courseSubjects:[],
      description:''
      
    };
  },
  mounted() {
    this.fetchDetailCourse();
  },
  methods: {
    fetchDetailCourse() {
      let obj = {
        _id: this.id,
      };

      HTTP.post(`detail/course`, obj).then((res) => {
        if (res.data.success) {
          this.courseSubjects = res.data.obj.subjects;
          this.description = res.data.obj.courseDescription
        }
      });
    },
  },
};
</script>

<style scoped>
.query-course-image {
  width: 270px;
  height: 200px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  border-radius: 8px;
}
.name-course{
  width: 80%;
}
</style>